import PropTypes                          from 'prop-types';
import React                              from 'react';
import NavBarTabletDropdownElementSubItem from './NavBarTabletDropdownElementSubItem';
import ReloadHelper                       from '../../utils/ReloadHelper';
import NavBarNewIcon                      from './NavBarNewIcon';
import { generateKey } 					  from '../../utils/CommonUtils';

class NavBarTabletDropdownElement extends React.PureComponent {

    constructor(props) {
		super(props);
		this.onClick = this.onClickButton.bind(this);
	}

	onClickButton(e) {
		// if no sub elements - navigate
		if (this.props.subElements.length === 0) {
			ReloadHelper.reloadWithPjax(this.props.link, e);
		} else {
			e.preventDefault();
		}
	}

	render() {
		const subListItems = this.props.subElements.map((entry, idx) => {
			const caption = entry ? entry.caption : '';
			return (
				<NavBarTabletDropdownElementSubItem
					{...entry}
					key={generateKey(caption, idx)}
				/>
			);
		}),
		icon = this.props.subElements.length > 0
			? <i
				key={generateKey('icon', subListItems.length)}
				className="icon -icon-single-arrow-down-line navbar-tablet__dropdown-link-icon"/>
			: null,
		specialIcon =
			this.props.hasSale
			? <img
				key={generateKey('specialIcon', subListItems.length)}
				className="navbar__icon-sale -tablet" src="/assets/img/special/videosale/navbar_badge_sale.png"/>
			: (this.props.isNew ? <NavBarNewIcon isTablet={true}/> : null);


		let linkClass = 'navbar-tablet__dropdown-link';
		if (this.props.subElements.length > 0) {
			linkClass += ' js-dropdown-toggle';
		}

		return (
			<li className="navbar-tablet__dropdown-item h-float-none">
				<a href="#" onClick={this.onClick} className={linkClass}>
					{this.props.name} {specialIcon} {icon}
				</a>
				<ul className="navbar-tablet__dropdown-submenu">{subListItems}</ul>
			</li>
		);
	}

}

NavBarTabletDropdownElement.propTypes = {
	name:        PropTypes.string,
	link:        PropTypes.string,
	isNew:       PropTypes.bool,
	hasSale:     PropTypes.bool,
	subElements: PropTypes.array,
};

NavBarTabletDropdownElement.defaultProps = {
	subElements: [],
	isNew:       false,
};

export default NavBarTabletDropdownElement;
